import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { LogIn } from 'lucide-react';

export const LoginPage = () => {
  const location = useLocation();
  const errorMessage = location.state?.error;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 relative">
      <div className="relative z-10 max-w-md w-full mx-4">
        <div className="bg-white rounded-lg shadow-xl p-8 border">
          <div className="text-center mb-8">
            <div className="flex justify-center mb-4">
              <img src="/logo.png" alt="AdvantEdge Advisory" className="h-20 w-auto" />
            </div>
            <p className="text-muted-foreground">
              Integrated Business Operations Platform
            </p>
          </div>
          {errorMessage && (
            <div className="mb-4 p-3 rounded-md bg-destructive/10 border border-destructive/30 text-destructive text-sm text-center" data-testid="auth-error">
              {errorMessage}
            </div>
          )}
          <Button
            onClick={handleLogin}
            className="w-full h-12 text-base"
            data-testid="login-button"
          >
            <LogIn className="mr-2 h-5 w-5" />
            Sign in with Google
          </Button>
        </div>
      </div>
    </div>
  );
};
